import React from 'react'

export const InstagramIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke="white" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="4" stroke="white" strokeWidth="1.8" />
    <circle cx="17.5" cy="6.5" r="1.1" fill="white" />
  </svg>
)

export const LinkedinIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.98 3.5C3.34 3.5 2 4.84 2 6.48c0 1.63 1.34 2.98 2.98 2.98h.02c1.65 0 2.98-1.35 2.98-2.98C7.98 4.84 6.65 3.5 4.98 3.5zM2.4 21.5h5.16V8.98H2.4V21.5zM9.5 8.98v12.52h5.16v-6.98c0-1.86 1.02-3.02 2.6-3.02 1.44 0 2.34 1 2.34 3.02v6.98h5.16v-7.62c0-4.16-2.22-6.1-5.18-6.1-2.4 0-3.46 1.36-4.06 2.32V8.98H9.5z" />
  </svg>
)

export const EnvelopeIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke="white" strokeWidth="1.8" />
    <path d="M3 6.5l9 6.5 9-6.5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
